import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import { IRootState } from '../../../typings';
import { fetchMatchVideos } from '../actions';

type IOwnProps = RouteComponentProps;

const mapDispatchToProps = {
  fetchMatchVideos,
};

const mapStateToProps = (state: IRootState) => ({
  matchVideos: state.matchVideos.list,
  fetching: state.matchVideos.fetching,
  pagination: state.matchVideos.pagination,
  total: state.matchVideos.totalItems,
});

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  IOwnProps;

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);

export const connector = compose<IComponentProps>(reduxConnector, injectIntl);
